import { FileDropzone } from "components/FileDropzone";

interface Props {
  files: File[];
  onFilesChange: (files: File[]) => void;
  onFileErrors: (errors: string[]) => void;
  onClose: VoidFunction;
}

export function FileUpload(props: Props) {
  const { files, onFilesChange, onFileErrors, onClose } = props;
  return (
    <FileDropzone
      files={files}
      onFilesChange={onFilesChange}
      onFileErrors={onFileErrors}
      onClose={onClose}
    />
  );
}
